// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"b1b825bf","513":"a534f269","703":"64fa88d9","787":"b904f03f"}[chunkId] + ".chunk.js";
};